import { Field, FieldProps } from 'formik'
import { get } from 'lodash'
import { ReactNode } from 'react'
import styled from 'styled-components'

const Subtitle = styled.div`
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.75rem;
  margin-top: 0.4rem;
`

// These are the props required
interface HocProps {
  name: string
  subtitle?: ReactNode
  renderErrors?: boolean
}

// These are the props that are obtained from other places (formik)
interface ComponentFieldProps {
  form: FieldProps['form']
}

// These are the sum of all props that are injected, and can be consumed within the wrapped component
export type withFieldProps = HocProps & ComponentFieldProps & FieldProps['field']

type Comp<T> = (props: T) => JSX.Element

interface ErrorRowProps {
  children: ReactNode
  isTouched?: boolean
}
const ErrorRow = ({ children, isTouched = false }: ErrorRowProps) => {
  if (!children || !isTouched) return null
  return <div className="field__error mt-0 !mb-0 font-normal text-red-500">{children}</div>
}

export function withField<P>(Wrapped: Comp<P>) {
  return function FieldWrapper(props: Omit<P, keyof ComponentFieldProps | keyof FieldProps['field']> & HocProps) {
    const { subtitle, name, renderErrors = true } = props
    return (
      <Field name={name}>
        {(fieldProps: FieldProps) => {
          const fieldErrors = get(fieldProps, `form.errors.${name}`)
          const isTouched = get(fieldProps, `form.touched.${name}`, false) as boolean

          const formikProps: ComponentFieldProps = {
            form: fieldProps.form
          }

          return (
            <>
              <Wrapped {...formikProps} {...fieldProps.field} {...(props as P & HocProps)} />
              {/* @ts-expect-error */}
              {renderErrors && <ErrorRow isTouched={isTouched}>{fieldErrors}</ErrorRow>}
              {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
            </>
          )
        }}
      </Field>
    )
  }
}
